import { TechDocument } from './tech-document.model';
import { Tech } from './tech.model';

export class TechRelease extends Tech {
  value?: number;
  payment_date?: Date;
  document?: TechDocument;

  constructor(json?: any) {
    super(json);
    if (!json) return;
    this.value = json['value'];
    this.payment_date = json['payment_date']
      ? new Date(json['payment_date'])
      : undefined;
    this.document = json['document']
      ? new TechDocument(json['document'])
      : undefined;
  }

  hasDocument(): boolean {
    return this.document != undefined;
  }
}
